 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCVI from '@/components/text/cvi'
 import TEXTTP from '@/components/text/tp'
 import TEXTALSOBY from '@/components/text/alsoby'
 import TEXTCOP from '@/components/text/cop'
 import TEXTTOC from '@/components/text/toc'
 import TEXTC01 from '@/components/text/c01'
 import TEXTEXCERPTINTRO from '@/components/text/excerpt-intro'
 import TEXTEXCERPT from '@/components/text/excerpt'
 import TEXTACK from '@/components/text/ack'
 import TEXTATA from '@/components/text/ata'
 import TEXTTY from '@/components/text/ty'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/toc",
 			"name" : "text/toc",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/text/c01",
 			"name" : "text/c01",
 			"component" : TEXTC01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js